import pako from "pako";
import { debugLog, debugDebug } from "@/utils/debugLog";

export const compress = (data) => {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(data);
  const compressed = pako.deflate(bytes, { level: 1 });
  return {
    data: compressed,
    stats: {
      originalBytes: bytes.length,
      compressedBytes: compressed.length,
      savingsPercent: ((1 - compressed.length / bytes.length) * 100).toFixed(1),
    },
  };
};

export const decompress = (compressedData) => {
  const decompressed = pako.inflate(compressedData);
  const decoder = new TextDecoder();
  const text = decoder.decode(decompressed);
  return {
    data: text,
    stats: {
      compressedBytes: compressedData.length,
      decompressedBytes: decompressed.length,
      savingsPercent: (
        (1 - compressedData.length / decompressed.length) *
        100
      ).toFixed(1),
    },
  };
};

export class CompressionMetrics {
  constructor(sessionId) {
    this.sessionId = sessionId;
    this.totalOriginalBytes = 0;
    this.totalCompressedBytes = 0;
    this.messageCount = 0;
  }

  record(stats, direction = "out") {
    const original =
      direction === "out" ? stats.originalBytes : stats.decompressedBytes;
    const compressed =
      direction === "out" ? stats.compressedBytes : stats.compressedBytes;

    this.totalOriginalBytes += original;
    this.totalCompressedBytes += compressed;
    this.messageCount += 1;

    debugDebug(
      `[${this.sessionId}] WS ${direction}: ${original} -> ${compressed} bytes (${stats.savingsPercent}% savings)`,
    );
  }

  summary() {
    const totalRatio =
      this.totalOriginalBytes > 0
        ? this.totalCompressedBytes / this.totalOriginalBytes
        : 1;
    return {
      sessionId: this.sessionId,
      messageCount: this.messageCount,
      totalOriginalBytes: this.totalOriginalBytes,
      totalCompressedBytes: this.totalCompressedBytes,
      totalSavingsPercent: ((1 - totalRatio) * 100).toFixed(1),
    };
  }

  logSummary() {
    const s = this.summary();
    debugLog(
      `[${s.sessionId}] Compression summary: ${s.messageCount} messages, ` +
        `${s.totalOriginalBytes} -> ${s.totalCompressedBytes} bytes ` +
        `(${s.totalSavingsPercent}% total savings)`,
    );
  }
}
